module.exports = __webpack_public_path__ + "img/flow_blue.c81abbb6.svg";